import type { Theme, SxProps } from '@mui/material';

import { Box, ButtonBase } from '@mui/material';

import { useOrganisation } from 'src/organisation';

const OrganisationLogoHeader = () => {
  const mediaQuery = 'sm';
  const { organizationName = '', organizationLogo } = useOrganisation();

  const buttonBg: SxProps<Theme> = {
    height: 1,
    zIndex: -1,
    opacity: 0,
    content: "''",
    borderRadius: 1,
    position: 'absolute',
    visibility: 'hidden',
    bgcolor: 'action.hover',
    width: 'calc(100% + 8px)',
    transition: (theme) =>
      theme.transitions.create(['opacity', 'visibility'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
  };

  // Get first letter fallback
  const getInitial = () =>
    organizationName.trim().charAt(0).toUpperCase() || '?';

  return (
    <ButtonBase
      disableRipple
      onClick={() => {}}
      sx={[
        {
          py: 0.5,
          gap: { xs: 0.5, [mediaQuery]: 1 },
          '&::before': buttonBg,
          position: 'relative',
        },
      ]}
    >
      {organizationLogo ? (
        <Box
          component="img"
          alt={organizationName}
          src={organizationLogo}
          sx={{ width: 32, height: 32, borderRadius: '8%' }}
        />
      ) : (
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '8%',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            typography: 'subtitle2',
          }}
        >
          {getInitial()}
        </Box>
      )}

      <Box
        component="span"
        sx={{
          typography: 'subtitle2',
          display: { xs: 'none', [mediaQuery]: 'inline-flex' },
        }}
      >
        {organizationName}
      </Box>
    </ButtonBase>
  );
};

export default OrganisationLogoHeader;
